import { render, staticRenderFns } from "./ManagerMenu.vue?vue&type=template&id=d52a1720&"
import script from "./ManagerMenu.vue?vue&type=script&lang=ts&"
export * from "./ManagerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports